"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.supportedLevels = exports.meetsLevel = exports.supportsLevel = void 0;
/**
 * Supported Levels
 * Logging levels are prioritized from 0-4
 */
const supportedLevels = {
    fatal: 0,
    error: 0,
    warn: 1,
    notice: 1,
    deprecated: 1,
    info: 2,
    local: 3,
    debug: 3,
    timing: 3,
    network: 3,
    trace: 3,
};
exports.supportedLevels = supportedLevels;
/**
 * Check if level is supported
 * @param {string} level
 */
function supportsLevel(level) {
    return supportedLevels[level] !== undefined;
}
exports.supportsLevel = supportsLevel;
/**
 * Check if level meets maxLevel
 * @param {string} level
 * @param {string} maxLevel
 */
function meetsLevel(level, maxLevel) {
    if (supportsLevel(level) && supportsLevel(maxLevel)) {
        return supportedLevels[level] <= supportedLevels[maxLevel];
    }
    return false;
}
exports.meetsLevel = meetsLevel;
//# sourceMappingURL=supportedLevels.js.map